import ArrowUpRight from "@/components/Icons/ArrowUpRight";
import "./LinkWithArrowIcon.css";

// -------------------------------------------------------------------------------------

export default function LinkWithArrowIcon({
	text = "Link",
	href = "https://www.google.com",
	color = "var(--primary-dim)",
	hoverColor = "var(--primary-light)",
	size = 18,
}) {
	return (
		<a
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			className="link-w-icon"
			style={{ "--c": color, "--c-hover": hoverColor }}
		>
			{text}
			<ArrowUpRight size={size} />
		</a>
	);
}
